export enum Locale {
  EN_US = 'en-us',
  EN_CA = 'en-ca',
  ES_PR = 'es-pr',
  FR_CA = 'fr-ca',
}

export type Locales = typeof Locale[keyof typeof Locale];
